import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { CommandResult } from 'src/app/models/commandResult';
import { AuthService } from 'src/app/services/auth.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  public form: FormGroup;
  public hide = true;

  constructor(private authService: AuthService, private fb: FormBuilder, private loadingCtrl: LoadingController,
    private toastCtrl: ToastController, private navCtrl: NavController) {

    this.form = this.fb.group({
      document: ['', Validators.compose([
        Validators.required,

      ])],
      password: ['', Validators.compose([
        Validators.minLength(8),
        Validators.maxLength(20),
        Validators.required
      ])]
    });
  }

  ngOnInit() {
    const token = Security.getToken();
    if (token) {
      this.authService.validaToken().subscribe((data: boolean) => {
        if (data) {
          this.navCtrl.navigateRoot('/master');
          this.showMessage('Sentimos sua falta, ' + Security.getName() + ', seja bem vindo(a) de novo');
        } else {
          Security.clear();
          this.navCtrl.navigateRoot('/login');
        }
      },
        (error) => {
          Security.clear();
          this.showMessage(error.message);
          this.navCtrl.navigateRoot('/login');
        }
      );
    }
  }

  async login() {

    const loading = await this.loadingCtrl.create({ message: 'Autenticando...' });
    loading.present();

    this.authService.authenticate(this.form.value).subscribe((data: CommandResult) => {
      if (data.data.authenticated) {

        this.setToken(data);
        loading.dismiss();
        Security.setCoin(1);
        this.navCtrl.navigateRoot('/master');
      } else {
        this.showMessage(data.message);
        loading.dismiss();
        Security.clear();
      }
    },
      (error) => {
        this.showMessage(error.message);
        loading.dismiss();
        Security.clear();
      });
  }

  async setToken(data) {
    Security.set(data.data);
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  async submit() {
    if (this.form.invalid) {
      return;
    }
    this.login();
  }

  toggleHide() {
    this.hide = !this.hide;
  }

  gotToPage(page: string) {
    this.navCtrl.navigateRoot(page);
  }

}
